import {NgModule, Optional, SkipSelf} from '@angular/core';
import {CommonModule} from '@angular/common';

import {AuthService} from './auth/auth.service';
import {LoggedInService} from './services/loggedIn.service';
import {CommonBaseRoutingModule} from './common-base-routing.module';
// specific to website
import {LoggedInAuthentService} from './services/loggedInAuthentservice';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {ConsumeDataTokenInterceptor} from './interceptor/consume-data-token.interceptor';
import {VersionInterceptor} from './interceptor/version.interceptor';
import {AuthentWithCustomOktaService} from './auth/services/authent-with-custom-okta.service';
import {TranslatePipe} from '@ngx-translate/core';

// export function getAuthServiceClass() {
//   console.log('Authservice used: ', environment.authClass); // DEBUG
//   if (environment.authClass === 'AuthApimTineaService') {
//     return AuthApimTineaService;
//   } else if (environment.authClass === 'CommonApiWithOktaService') {
//     return CommonApiWithOktaService;
//   } else if (environment.authClass === 'CommonApiWithCustomOktaService') {
//     return CommonApiWithCustomOktaService;
//   } else {
//     console.error('getAuthServiceClass(): Auth class don\'t exists');
//   }
// }

@NgModule({
  imports: [
    CommonModule,
    TranslatePipe,
    CommonBaseRoutingModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ConsumeDataTokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: VersionInterceptor,
      multi: true
    },
    {provide: AuthService, useClass: AuthentWithCustomOktaService },
    {provide: LoggedInService, useClass: LoggedInAuthentService }
  ]
})
export class CommonBaseModule {

  constructor(@Optional() @SkipSelf() parentModule: CommonBaseModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded.');
    }
  }

}
